import { useQuery } from '@tanstack/react-query';
import { modelsApi } from '@/services/api';
import type { ModelInfo, ModelTaskType } from '@shared/types';

export function useModels(params?: { task?: string; search?: string }) {
  return useQuery({
    queryKey: ['models', params?.task, params?.search],
    queryFn: () => modelsApi.list(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
}

export function useModel(id: string | null) {
  return useQuery({
    queryKey: ['model', id],
    queryFn: () => modelsApi.get(id!),
    enabled: !!id,
    staleTime: 10 * 60 * 1000,
  });
}

export function useTasks() {
  return useQuery({
    queryKey: ['tasks'],
    queryFn: () => modelsApi.tasks(),
    staleTime: 10 * 60 * 1000,
  });
}

export function useModelsByTask(task: ModelTaskType | null, allModels?: ModelInfo[]) {
  if (!allModels || !task) return [];
  return allModels.filter((m) => m.task === task);
}

export function useFeaturedModels(allModels?: ModelInfo[]) {
  if (!allModels) return [];
  return allModels.filter((m) => m.featured);
}
